/**
 * Trustpilot only guarantees a display name when the reviewer set one, and the
 * feed occasionally returns it blank. Cards drop the attribution line entirely
 * in that case rather than rendering a bare dash.
 */
export function getReviewAttribution(name: string | undefined): string | undefined {
  const trimmed = name?.trim();

  return trimmed ? `— ${trimmed}` : undefined;
}
